module.exports = __webpack_public_path__ + "static/media/Thumbs.56f13792.db";